import type { AssociatedProduct } from "./typeGuards"
import { isAkrochemProduct } from "./typeGuards"

export const getProductName = (product: AssociatedProduct): string => {
  return (isAkrochemProduct(product) ? product.companyProductDescription : product.productName) || ""
}

export const getProductId = (product: AssociatedProduct): string => {
  return isAkrochemProduct(product) ? product.productId.toString() : product.competitorProductId
}

export const getCasNumbers = (product: AssociatedProduct): string[] => {
  return isAkrochemProduct(product) ? product.casRegistryIds || [] : product.casNumbers || []
}

export const getManufacturer = (product: AssociatedProduct): string => {
  return (isAkrochemProduct(product) ? product.company?.name : product.manufacturer) || ""
}

export const getDistributors = (product: AssociatedProduct): { externalSystemId: string; name: string }[] => {
  if (isAkrochemProduct(product)) {
    return [{ externalSystemId: "akrochem", name: "Akrochem" }]
  }

  const distributors = product.distributors || []
  return distributors.map((d) => ({
    externalSystemId: d.externalSystemId || "",
    name: d.name || "",
  }))
}

export const getSupplier = (product: AssociatedProduct): string => {
  return isAkrochemProduct(product) ? "Akrochem" : ""
}
